module.exports = __webpack_public_path__ + "img/write_review.6f68fdb9.svg";